import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Generic modal to display wordpress contents
 */
@Component({
	selector: 'app-word-press-overlay',
	templateUrl: './word-press-overlay.component.html',
	styleUrls: ['./word-press-overlay.component.scss'],
})
export class WordPressOverlayComponent implements OnInit {
	safeUrl: any;

	@ViewChild('iFrameElement') iframeRef: ElementRef<HTMLIFrameElement>;

	/**
	 * Component constructor
	 * @param dialogRef - mat dialog reference
	 * @param data - dialog input data
	 */
	constructor(
		private dialogRef: MatDialogRef<WordPressOverlayComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		window.onpopstate = function (event) {
			history.go(1);
		};
	}

	/**
	 * On component initialization
	 */
	ngOnInit() {
		this.safeUrl = this.data.url;
	}

	ngAfterViewInit() {
		if(this.safeUrl) {
			this.iframeRef.nativeElement.src = this.safeUrl;
		}
	}

	/**
	 * On dialog close
	 */
	close(): void {
		this.dialogRef.close(true);
	}
}
